"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateCheckboxes = exports.updateNAToUndefined = exports.serializeObject = exports.retainNumbersOnly = exports.mapObjectProperties = exports.luhnValidator = exports.isString = exports.isIe11 = exports.isEmptyString = exports.getFullYear = exports.getFullCardNumberType = exports.getCustomOrDefaultValue = exports.focusOnDOMElementWithId = exports.focusOnCustomFields = exports.disablePaymentMethod = exports.deserializeObject = exports.convertToAcceptedLocale = exports.convertBCP2Locale = exports.constructValidObject = exports.classExists = void 0;
var _constants = require("../constants/constants");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var NUMBERS_ONLY_REGEX = new RegExp(_constants.NUMBERS_ONLY);

/**
 * Check for both formats of a String.
 * It can be a string variable or a String instance
 *
 * @param value: Value to be compared
 * @returns {boolean}: true if it's a string or instance of String, else false.
 */
var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

/**
 * Helper function used to decide which value to pick from either of,
 * custom value provided by the Host application or the default value
 *
 * We allow only strings(including empty strings) for labels and placeholders
 *
 * @param customValue: Value from the host application.
 * @param defaultValue: Default value of the payment widget.
 * @returns {*}: customValue or defaultValue after comparison.
 */
exports.isString = isString;
var getCustomOrDefaultValue = function getCustomOrDefaultValue(customValue, defaultValue) {
  return isString(customValue) ? customValue : defaultValue;
};

/**
 * Given a certain list of classes, it will check if the class exists in the mounted dom or not.
 * This comes handy while checking for error class in DOM
 * @param classList: Array of string classes
 * @returns {boolean}: True if the class exists, otherwise false
 */
exports.getCustomOrDefaultValue = getCustomOrDefaultValue;
var classExists = function classExists(classList) {
  var _iterator = _createForOfIteratorHelper(classList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var className = _step.value;
      if (document.getElementsByClassName(className).length > 0) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};

/**
 * Moves the focus on a list of element references provided.
 * @param refs: A list of references
 */
exports.classExists = classExists;
var focusOnCustomFields = function focusOnCustomFields(refs) {
  var _iterator2 = _createForOfIteratorHelper(refs),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var ref = _step2.value;
      if (!ref) {
        continue;
      }
      var childInputFields = ref.getElementsByTagName('input');
      Array.from(childInputFields).forEach(function (el) {
        el.focus();
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

// Returns a string of the object
exports.focusOnCustomFields = focusOnCustomFields;
var serializeObject = function serializeObject(data) {
  return JSON.stringify(data);
};

// Returns an object from string
exports.serializeObject = serializeObject;
var deserializeObject = function deserializeObject(data) {
  return JSON.parse(data);
};

/**
 * Given a id, it checks if the child check boxes are checked or not
 * @param id: Accepts dom id
 * @returns {boolean}: True or False depending on whether the checkboxes are checked or not.
 */
exports.deserializeObject = deserializeObject;
var validateCheckboxes = function validateCheckboxes(id) {
  var checkboxes = document.querySelectorAll("#".concat(id, " input[type='checkbox']"));
  return Array.prototype.every.call(checkboxes, function (c) {
    return c.checked;
  });
};

/**
 * Given a localeCode in BCP 47 format, it return the same in five character locale code
 * @param bcp47Code: Accepts locale in BCP 47 format
 * @returns {string}: Returns locale
 * example: en-us --> en_US
 */
exports.validateCheckboxes = validateCheckboxes;
var convertBCP2Locale = function convertBCP2Locale(bcp47Code) {
  var _bcp47Code$split = bcp47Code.split('-'),
    _bcp47Code$split2 = _slicedToArray(_bcp47Code$split, 2),
    language = _bcp47Code$split2[0],
    region = _bcp47Code$split2[1];
  var regionInUpper = region.toUpperCase();
  var locale = [language, regionInUpper].join('_');
  return locale;
};
exports.convertBCP2Locale = convertBCP2Locale;
var getFullYear = function getFullYear(twoDigitYear) {
  var currentDate = new Date();
  var currentCentury = currentDate.getFullYear().toString().substr(0, 2);
  return currentCentury + twoDigitYear;
};
exports.getFullYear = getFullYear;
var isEmptyString = function isEmptyString(value) {
  // If the value is null or undefined we consider it as empty
  if (value == null) {
    return true;
  }
  return value.trim() === '';
};
exports.isEmptyString = isEmptyString;
var isIe11 = function isIe11() {
  return !!window.MSInputMethodContext && !!document.documentMode;
};
exports.isIe11 = isIe11;
var retainNumbersOnly = function retainNumbersOnly(value) {
  return value.replace(NUMBERS_ONLY_REGEX, '');
};
exports.retainNumbersOnly = retainNumbersOnly;
var getFullCardNumberType = function getFullCardNumberType(value) {
  var cardNumber = retainNumbersOnly(value);
  if (_constants.VISA_REGEX.test(cardNumber)) {
    return _constants.CARD_TYPES.VISA;
  } else if (_constants.MASTER_CARD_REGEX.test(cardNumber)) {
    return _constants.CARD_TYPES.MASTER_CARD;
  } else if (_constants.AMEX_CARD_REGEX.test(cardNumber)) {
    return _constants.CARD_TYPES.AMEX;
  } else if (_constants.DISCOVER_CARD_REGEX.test(cardNumber)) {
    return _constants.CARD_TYPES.DISCOVER;
  } else if (_constants.DINERS_CLUB_CARD_REGEX.test(cardNumber)) {
    return _constants.CARD_TYPES.DINERS_CLUB;
  } else {
    return '';
  }
};

//Recursive function that removes all the object properties with null values
exports.getFullCardNumberType = getFullCardNumberType;
var constructValidObject = function constructValidObject(obj) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] === null) {
      delete obj[key];
      return;
    }
    if (_typeof(obj[key]) === 'object') {
      constructValidObject(obj[key]);
    }
  });
};
/**Apply Luhn Check for the credit card number entered
 * Visit : https://en.wikipedia.org/wiki/Luhn_algorithm
 * **/
exports.constructValidObject = constructValidObject;
var luhnValidator = function luhnValidator(value) {
  var reduceToSingleDigit = function reduceToSingleDigit(number) {
    if (number <= 9) {
      return number;
    }
    return number - 9;
  };
  var cardNumber = retainNumbersOnly(value);
  // Ignore the checking if the length if less than 13, hence avoiding the unnecessary computation
  if (cardNumber.length < 13) {
    return false;
  }
  cardNumber = cardNumber.split('').map(function (ele) {
    return parseInt(ele);
  });
  cardNumber = cardNumber.reverse();
  var total = 0;
  for (var i = 0; i < cardNumber.length; ++i) {
    var number = cardNumber[i];
    if (i & 1) {
      number = reduceToSingleDigit(number * 2);
    }
    total += number;
  }
  return total % 10 === 0;
};
exports.luhnValidator = luhnValidator;
var disablePaymentMethod = function disablePaymentMethod(paymentMethodsList, paymentMethodToRemove) {
  return paymentMethodsList.filter(function (paymentMethod) {
    return paymentMethod != paymentMethodToRemove;
  });
};
exports.disablePaymentMethod = disablePaymentMethod;
var convertToAcceptedLocale = function convertToAcceptedLocale(locale) {
  /** We will firstly assign it to user provided locale
   * and update it. Even if it is a malformed one, we can
   * track it in pixel tracker
   */
  var acceptedLocale = locale;
  try {
    var lowerCaseLocale = locale.toLowerCase();
    if (lowerCaseLocale.includes('_')) {
      var splitLocale = lowerCaseLocale.split('_');
      acceptedLocale = splitLocale[0] + '-' + splitLocale[1];
    } else {
      var _splitLocale = lowerCaseLocale.split('-');
      acceptedLocale = _splitLocale[0] + '-' + _splitLocale[1];
    }
  } catch (err) {
    /**If we catch any error, which might be 
     * array index access error, this means the user
     * has not entered a well formed locale ex: en_US or en-us
     * Then we simply return back en-us locale
     * Also add add analytics code to track this
     */
    // Firstly track the user entered locale

    // Update to fallback locale
    acceptedLocale = 'en-us';
  }
  return acceptedLocale;
};
exports.convertToAcceptedLocale = convertToAcceptedLocale;
var focusOnDOMElementWithId = function focusOnDOMElementWithId(elementId) {
  var domElement = document.getElementById(elementId);
  if (domElement) {
    domElement.focus();
  }
};
exports.focusOnDOMElementWithId = focusOnDOMElementWithId;
var updateNAToUndefined = function updateNAToUndefined(obj) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] == 'N/A') {
      obj[key] = undefined;
    }
  });
};
exports.updateNAToUndefined = updateNAToUndefined;
var mapObjectProperties = function mapObjectProperties(obj, mapper) {
  var mappedObject = {};
  for (var _i2 = 0, _Object$entries = Object.entries(obj); _i2 < _Object$entries.length; _i2++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (mapper[key]) {
      mappedObject[mapper[key]] = value;
    }
  }
  return mappedObject;
};
exports.mapObjectProperties = mapObjectProperties;